import _ from 'lodash';
//import { apiSearch, apiFetch} from './utility';
import { apiSearch } from './utility';

const apiBase = 'biodieselFormula';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

